import * as React from 'react';
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next";

import { AutoComplete, DropDownList } from "@progress/kendo-react-dropdowns";
import { Grid, GridToolbar, GridColumn as Column } from '@progress/kendo-react-grid';
import { filterBy, toODataString } from '@progress/kendo-data-query';
import { LocalizationProvider, loadMessages, load, IntlProvider } from '@progress/kendo-react-intl';
import { FloatingLabel } from "@progress/kendo-react-labels";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { DatePicker } from "@progress/kendo-react-dateinputs";

import { ListOfPaged, MinimumPage } from "../../classes/consts";
import { CustomListCommandCellWithRemove } from "../../components/GridCustomListCommandCell";
import { ProcessError, ErrorCode } from "../../classes/ExceptionProcessor";
import { Input, Checkbox } from '@progress/kendo-react-inputs';



import LicencesService from "../../services/licenses.service";
import ClientsService from "../../services/clients.service";
import LicenseRequestService from "../../services/licenserequests.service";
import LicenceTagsService from "../../services/licenseTags.service";

import esMessages from '../../telerikResources/es.json';
import enMessages from '../../telerikResources/en.json';
import caMessages from '../../telerikResources/ca.json';

import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";
import numbers from "cldr-numbers-full/main/es/numbers.json";
import caGregorian from "cldr-dates-full/main/es/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/es/dateFields.json";
import timeZoneNames from "cldr-dates-full/main/es/timeZoneNames.json";

import cadateFields from "cldr-dates-full/main/ca/dateFields.json";
import catimeZoneNames from "cldr-dates-full/main/ca/timeZoneNames.json";
import caCAGregorian from "cldr-dates-full/main/ca/ca-gregorian.json";

load(
    likelySubtags,
    currencyData,
    weekData,
    numbers,
    caGregorian,
    dateFields,
    timeZoneNames,
    cadateFields,
    catimeZoneNames,
    caCAGregorian

);

loadMessages(esMessages, 'es');
loadMessages(caMessages, 'ca');
loadMessages(enMessages, 'en');

export default function List(props) {

    const { t } = useTranslation();

    // Grid Hooks
    const [sortState, setSortState] = React.useState([{
        field: "creationDate",
        dir: "desc",
    },]);
    const [pageState, setPageState] = React.useState({ skip: 0, take: MinimumPage() });
    const [total, setTotal] = React.useState(0);

    // Error Hooks
    const [visibleError, setVisibleError] = React.useState(false);
    const [errorData, setErrorData] = React.useState({ messageError: "", code: "" });

    // Delete Event Hooks
    const [visibleRemove, setVisibleRemove] = React.useState(false);
    const [dataItemToRemove, setDataItemToRemove] = React.useState({});

    // Data Hooks
    const [licencesData, setLicencesData] = React.useState([]);
    const [applicationsData, setApplicationsData] = React.useState([]);
    const [selectedApplication, setSelectedApplication] = React.useState(null);

    // Loading Hooks
    const [loading, setLoading] = React.useState(true);
    const [loadingClients, setLoadingClients] = React.useState(true);
    const [refresh, setRefresh] = React.useState(false);

    // Filter Hooks
    const [clientsFilter, setClientsFilter] = React.useState([]);
    const [filterData, setFilterData] = React.useState({ active: null, created: null, appId: "", clientId: 0, tagName: "" });

    const [clientsFilterNames, setClientsFilterNames] = React.useState([]);
    const [stateClientFilter, setStateClientFilter] = React.useState({ data: clientsFilterNames, value: "", });
    const [selectedClientFilter, setSelectedClientFilter] = React.useState("");
    const [filterString, setFilterString] = React.useState("");
    const [statusModes, setStatusModes] = React.useState([]);
    const [statusModeSelected, setStatusModeSelected] = React.useState(null);

    const [isAnySelected, setIsAnySelected] = React.useState(false);


    // Aspect Functions

    const [tagsData, setTagsData] = React.useState([]);

    //*****************************************************************//

    const [tagInputs, setTagInputs] = React.useState([{ tag: null, value: "" }]);


    const addTagInput = () => {
        setTagInputs([...tagInputs, { tag: null, value: "" }]);
    };

    const handleTagChange = (index, selectedTag) => {
        const newInputs = [...tagInputs];
        newInputs[index].tag = selectedTag;
        setTagInputs(newInputs);
    };

    const handleValueChange = (index, e) => {
        const newInputs = [...tagInputs];
        newInputs[index].value = e.target.value;
        setTagInputs(newInputs);
    };

    const removeTagInput = (indexToRemove) => {
        setTagInputs(prev => prev.filter((_, index) => index !== indexToRemove));
    };


    //****************************************************************//

    const CommandCell = React.useCallback(cellProps => (
        <CustomListCommandCellWithRemove
            {...cellProps}
            editField='inEdit'
            remove={remove}
            linkToDetails={'/licenses/' + cellProps.dataItem.licenseId + '/""/Details'}
            isAdmin={props.isAdmin}

        />
    ), [props]);

    //AGREGUE NUEVO CAMPO DE CHECKBOX
    const handleCheckboxChange = (licenseId) => {
        setLicencesData(prevData =>
            prevData.map(license =>
                license.licenseId === licenseId
                    ? { ...license, selected: !license.selected }
                    : license
            )
        );
    };


    const CheckboxCell = React.useCallback(cellProps => (
        <td className="k-command-cell" style={{ textAlign: "center" }}>
            <Checkbox
                checked={cellProps.dataItem.selected || false}
                onChange={() => handleCheckboxChange(cellProps.dataItem.licenseId)}
            />
        </td>
    ), []);

    const getSelectedLicenses = async () => {
        const selectedLicenses = licencesData.filter(license => license.selected);

        try {
            // Para cada licencia seleccionada, enviar la solicitud PATCH para deshabilitarla
            for (const license of selectedLicenses) {
                const patchupdateLicense = {
                    isDisabled: true,
                };
                // Llamada a la API para actualizar la licencia
                await LicencesService.patchupdateLicense(license.licenseId, patchupdateLicense);
            }

            alert("Licencias deshabilitadas exitosamente.");
            setRefresh(true);
        } catch (err) {
            console.error("Error al deshabilitar licencias:", err);
            alert("Hubo un error al deshabilitar las licencias.");
        }
    };

    React.useEffect(() => {
        const anySelected = licencesData.some(license => license.selected);
        setIsAnySelected(anySelected);
    }, [licencesData]);

    const AllowUpdatesCommandCell = React.useCallback(cellProps => (
        <td className="k-command-cell" style={{ textAlign: "center" }}>
            {
                (cellProps.dataItem.allowUpdates === true) ? <span className='k-icon k-i-cloud' title={t("Licenses_AllowUpdates_TooltipText")} />
                    : <span className='k-icon k-i-close' title={t("Licenses_NotAllowUpdates_TooltipText")} />
            }

        </td>

    ), [t]);

    const IsDisabledCommandCell = React.useCallback(cellProps => (
        <td className="k-command-cell" style={{ textAlign: "center" }}>
            {
                (cellProps.dataItem.isDisabled === true) ? <span className='k-icon k-i-close' title={t("Licenses_Disabled_TooltipText")} />
                    : <span className='k-icon k-i-check' title={t("Licenses_Enabled_TooltipText")} />
            }

        </td>
    ), [t]);

    const loadingPanel =
        <div className="k-loading-mask">
            <span className="k-loading-text">Loading</span>
            <div className="k-loading-image"></div>
            <div className="k-loading-color"></div>
        </div>
        ;

    const MachineCodeTruncateCommandCell = React.useCallback(cellProps => (
        <td className="k-command-cell">
            {
                (cellProps.dataItem.machineCode === null) ? "" : cellProps.dataItem.machineCode.slice(0, 20) + "..."

            }

        </td>

    ), []);

    const LicenseCodeTruncateCommandCell = React.useCallback(cellProps => (
        <td className="k-command-cell">
            {
                cellProps.dataItem.licenseCode.slice(0, 20) + "..."
            }

        </td>

    ), []);

    const loadingCell = React.useCallback((tdElement, cellProps) => {
        if (cellProps.dataItem[cellProps.field] === undefined) {
            // shows loading cell if no data
            return <td> <span className="k-placeholder-line"></span></td>;
        }

        // default rendering for this cell
        return tdElement;
    }, []);

    // Action Functions

    const remove = (dataItem) => {

        setDataItemToRemove(dataItem);
        setVisibleRemove(true);

    }

    const removeDataItem = () => {
        setLoading(true);
        LicencesService.deleteLicense(dataItemToRemove.licenseId).then(() => {
            setDataItemToRemove({});
            setRefresh(true);
            setVisibleRemove(false);
        }).catch((err) => {
            setDataItemToRemove({});
            setVisibleError(true);
            setVisibleRemove(false);
            setErrorData({ messageError: ProcessError(err), code: ErrorCode(err) });
        });
    }

    // Effects

    React.useEffect(() => {
        if (applicationsData.length > 0 && clientsFilter.length > 0) {
            const storedFilterState = sessionStorage.getItem("license_list");

            if (storedFilterState) {
                const license_list = JSON.parse(storedFilterState);

                setSelectedClientFilter(license_list.clientFilter);
                setFilterData(prev => ({
                    ...prev,
                    appId: license_list.appId,
                    clientId: license_list.clientId,
                    created: license_list.createdDate ? new Date(license_list.createdDate) : null,
                    active: license_list.active,
                    tagName: license_list.tagName,
                }));

                if (license_list.tags && Array.isArray(license_list.tags)) {
                    setTagInputs(license_list.tags);
                }

                let clientId = license_list.clientFilter
                    ? license_list.clientFilter.replace(/ClientId eq (\d+)/, "$1")
                    : "";

                let clientSelected = clientsFilter.find(client => client.clientId === parseInt(clientId));

                if (clientSelected) {
                    setStateClientFilter({
                        data: filterDataByClient(clientSelected.name),
                        value: clientSelected.name,
                    });
                } else {
                    setStateClientFilter({
                        data: filterDataByClient(""),
                        value: "",
                    });
                }

                setSelectedApplication(
                    applicationsData.find(app => app.appId === license_list.appId) ||
                    { appId: -1, applicationName: t("Global_DropDownFilter_None_Selected") }
                );


                if (license_list.active !== null) {
                    let selectedMode = statusModes.find(item => item.value === (license_list.active ? 1 : 2));
                    setStatusModeSelected(selectedMode || { name: t("License_All_StatusMode_SelectList"), value: 3 });
                } else {
                    setStatusModeSelected({ name: t("License_All_StatusMode_SelectList"), value: 3 });
                }



                let filter = "";

                if (license_list.clientFilter !== "")
                    filter += license_list.clientFilter;

                if (license_list.appId !== "")
                    filter += (filter ? " and " : "") + `AppId eq '${license_list.appId}'`;

                if (license_list.clientId !== 0)
                    filter += (filter ? " and " : "") + `ClientId eq ${license_list.clientId}`;

                if (license_list.createdDate !== null)
                    filter += (filter ? " and " : "") + `CreationDate ge ${new Date(license_list.createdDate).toJSON()}`;

                if (license_list.active !== null)
                    filter += (filter ? " and " : "") + `IsDisabled eq ${license_list.active}`;


                //****************************************************************************//

                if (license_list.tags && Array.isArray(license_list.tags)) {
                    license_list.tags.forEach(({ tag, value }) => {
                        if (tag && tag.tagName) {
                            filter += (filter ? " AND " : "") + `LicenseTagName eq '${tag.tagName}'`;
                        }

                        if (value && value.trim() !== "") {
                            filter += (filter ? " AND " : "") + `contains(LicenseTagValue,'${value}')`;
                        }
                    });
                }


                //console.log(filter);
                setFilterString(filter);
            }
        }
    }, [applicationsData, clientsFilter, t]);


    React.useEffect(() => {

        setLoadingClients(true);
        setLoading(true);

        ClientsService.getClients()
            .then(response => response.data)
            .then(json => {
                json.splice(0, 0, { clientId: null, name: "", remarks: "" })
                setLoadingClients(false);
                json.splice(0, 0, { clientId: null, name: t("Licenses_ClientFilter_All_Text"), remarks: "" })
                setClientsFilter(json);
                setClientsFilterNames(json.map((e) => e.name));
                setLoadingClients(false);
            }).catch((err) => {
                setVisibleError(true);
                setLoading(false);
                setErrorData({ messageError: ProcessError(err), code: ErrorCode(err) });
            });

        LicenseRequestService.getListOfApplications().then(data => {
            data.push({ appId: "", applicationName: t("Global_DropDownFilter_None_Selected") });
            setSelectedApplication({ appId: "", applicationName: t("Global_DropDownFilter_None_Selected") });
            setApplicationsData(data);
        });

        LicenceTagsService.getLicenseTagsFiltered("", "", Math.ceil((pageState.skip + 1) / pageState.take), pageState.take)
            .then(response => response.data)
            .then(json => {
                // Agregar la opción "Todos"
                // json.contract.unshift({ tagName: t("Global_DropDownFilter_None_Selected") }); // Usamos tagName para "Todos"
                setTagsData(json.contract);
                //setSelectedTag({ tagName: t("Global_DropDownFilter_None_Selected") }); // Seleccionar "Todos" por defecto
                setLoading(false);
            }).catch((err) => {
                setVisibleError(true);
                setLoading(false);
                setErrorData({ messageError: ProcessError(err), code: ErrorCode(err) });
            });
    }, [t]);

    React.useEffect(() => {

        let newData = [{ name: t("License_Active_StatusMode_SelectList"), value: 1 },
        { name: t("License_Disabled_StatusMode_SelectList"), value: 2 },
        { name: t("License_All_StatusMode_SelectList"), value: 3 }];

        setStatusModes(newData);

        if (statusModeSelected != null) {
            let newSelected = newData.find(y => y.value === statusModeSelected.value);
            setStatusModeSelected(newSelected);
        } else {
            setStatusModeSelected({ name: t("License_All_StatusMode_SelectList"), value: 3 });
            console.log({ name: t("License_All_StatusMode_SelectList"), value: 3 });
        }

    }, [t]);


    React.useEffect(() => {

        const loadData = () => {
            setRefresh(false);
            setLoading(true);

            console.log("hola" + filterString);

            let oDataString = toODataString({ sort: sortState });
            oDataString = oDataString.replace("name", "Name");
            oDataString = oDataString.replace("clientName", "ClientName");
            oDataString = oDataString.replace("creationDate", "CreationDate");
            oDataString = oDataString.replace("$orderby", "?orderBy");

            LicencesService.getLicensesFiltered(filterString, oDataString, Math.ceil((pageState.skip + 1) / pageState.take), pageState.take)
                .then(response => response.data)
                .then(json => {
                    json.contract.map((item) => {
                        let newDate = new Date(item.creationDate);
                        newDate.setHours(0, 0, 0, 0);
                        item.creationDate = newDate;
                        return item;
                    })
                    setLicencesData(json.contract);
                    setTotal(json.totalResults);
                    setLoading(false);
                }).catch((err) => {
                    setVisibleError(true);
                    setLoading(false);
                    setErrorData({ messageError: ProcessError(err), code: ErrorCode(err) });
                });
        };

        loadData();

    }, [pageState, filterString, sortState, refresh]);


    const clickFilter = () => {

        let filter = "";

        if (selectedClientFilter !== "")
            filter += selectedClientFilter;

        if (filterData.appId !== "")
            if (filter === "")
                filter += "AppId eq '" + filterData.appId + "'";
            else
                filter += " and AppId eq '" + filterData.appId + "'";

        if (filterData.clientId !== 0)
            if (filter === "")
                filter += "ClientId eq " + filterData.clientId;
            else
                filter += " and ClientId eq " + filterData.clientId;

        if (filterData.created !== null)
            if (filter === "")
                filter += "CreationDate ge " + filterData.created.toJSON();
            else
                filter += " and CreationDate ge " + filterData.created.toJSON();

        if (filterData.active !== null)
            if (filter === "")
                filter += " IsDisabled eq " + (filterData.active);
            else
                filter += " and IsDisabled eq " + (filterData.active);

        tagInputs.forEach(({ tag, value }) => {
            if (tag && tag.tagName) {
                if (filter !== "") filter += " AND ";
                filter += `LicenseTagName eq '${tag.tagName}'`;
            }

            if (value && value.trim() !== "") {
                if (filter !== "") filter += " AND ";
                filter += `contains(LicenseTagValue,'${value}')`;
            }
        });

        console.log(filter);
        setPageState(prev => ({ ...prev, skip: 1 }))
        setFilterString(filter);

        const license_list = {
            clientFilter: selectedClientFilter,
            appId: filterData.appId,
            clientId: filterData.clientId,
            createdDate: filterData.created ? filterData.created.toISOString() : null, // Convertimos a ISO string
            active: filterData.active,
            tags: tagInputs,
        };

        sessionStorage.setItem("license_list", JSON.stringify(license_list));

    }

    const clearFilters = () => {
        sessionStorage.removeItem("license_list");

        setSelectedClientFilter("");
        setStateClientFilter({
            data: [],
            value: "",
        });
        setFilterData(prev => ({
            ...prev,
            appId: "",
            clientId: 0,
            created: null,
            active: null,
            tagName: "",
        }));

        setTagInputs([{ tag: null, value: "" }]);
        setSelectedApplication({ appId: -1, applicationName: t("Global_DropDownFilter_None_Selected") }); // Limpiar la aplicación seleccionada
        setStatusModeSelected({ name: t("License_All_StatusMode_SelectList"), value: 3 }); // Limpiar el estado del modo
        setFilterString("");

    };

    const filterDataByClient = React.useCallback((value) => {
        const filter = {
            value: value,
            operator: "startswith",
            ignoreCase: true,
        };

        return value ? filterBy(clientsFilterNames, filter) : clientsFilterNames;
    }, [clientsFilterNames]);

    const FilterByClient = React.useCallback((client) => {

        let clientSelected = clientsFilter.find(obj => {
            return obj.name === client;
        })

        if (clientSelected != null && clientSelected?.name !== "") {

            setSelectedClientFilter("ClientId eq " + clientSelected.clientId);
            setStateClientFilter({
                data: filterDataByClient(clientSelected.name),
                value: clientSelected.name,
            });

        } else {

            setSelectedClientFilter("");
            setStateClientFilter({
                data: filterDataByClient(client),
                value: client,
            });
        }

    }, [clientsFilter, filterDataByClient]);

    const sortChange = React.useCallback((event) => {
        setSortState(event.sort);
    }, []);

    const pageChange = React.useCallback((event) => {
        setPageState(prev => ({ ...prev, skip: event.page.skip, take: event.page.take }));
    }, []);

    const closeDialogError = React.useCallback(() => { setVisibleError(false) }, []);
    const closeDialogRemove = React.useCallback(() => { setVisibleRemove(false) }, []);
    const filterClient = React.useCallback(e => FilterByClient(e.target.value), [FilterByClient]);
    const filterAppId = React.useCallback(e => {
        setSelectedApplication(e.value);
        setFilterData(prev => ({ ...prev, appId: e.value.appId }));
    }, []);
    const filterCreationDate = React.useCallback(e => {
        setFilterData(prev => ({ ...prev, created: new Date(e.value) }));
    }, []);
    const filterIsDisabled = React.useCallback(e => {
        //Se cambio los valores dentro de los if en 1: false por true y 2: true por false   
        if (e.value.value === 1)
            setFilterData(prev => ({ ...prev, active: true }));

        else if (e.value.value === 2)
            setFilterData(prev => ({ ...prev, active: false }));
        else
            setFilterData(prev => ({ ...prev, active: null }));

        setStatusModeSelected(e.value);

    }, []);

    return (
        <div>
            {visibleError && (
                <Dialog title={"Error " + errorData.code} onClose={closeDialogError}>
                    <p style={{ margin: "25px", textAlign: "center" }}>
                        <b>{errorData.messageError}</b>
                    </p>
                    <DialogActionsBar>
                        <button className="k-button" onClick={closeDialogError}>
                            OK
                        </button>
                    </DialogActionsBar>
                </Dialog>
            )}
            {visibleRemove && (
                <Dialog title={t("Global_RemoveDialog_Title")} onClose={closeDialogRemove}>
                    <p style={{ margin: "25px", textAlign: "center" }}>
                        <b>{t("Global_RemoveDialog_Text") + " \"" + dataItemToRemove.licenseId + "\" ?"} </b>
                    </p>
                    <DialogActionsBar>
                        <button className="k-button" onClick={() => removeDataItem()}>
                            {t("Global_OKButton_Text")}
                        </button>
                        <button className="k-button" onClick={closeDialogRemove}>
                            {t("Global_CancelButton_Text")}
                        </button>
                    </DialogActionsBar>
                </Dialog>
            )}
            <LocalizationProvider language={localStorage.getItem("i18nextLng") === null ? "en" : localStorage.getItem("i18nextLng")}>
                <IntlProvider locale={localStorage.getItem("i18nextLng") === null ? "en" : localStorage.getItem("i18nextLng")}>
                    <div className="card">
                        <div className="card-body container-fluid">
                            <div className="row">
                                <div className="col-lg-2" >
                                    <FloatingLabel
                                        style={{ width: "100%" }}
                                        label={t("License_ClientId_Label")}
                                        editorId={"clientsFilterSelector"}
                                        editorValue={loading ? "" : "null"}
                                    >
                                        <AutoComplete
                                            style={{ width: "100%" }}
                                            id={"clientsFilterSelector"}
                                            loading={loadingClients}
                                            data={stateClientFilter.data}
                                            value={stateClientFilter.value}
                                            onChange={filterClient}
                                        />
                                    </FloatingLabel>
                                </div>
                                <div className="col-lg-2" >
                                    <DropDownList
                                        label={t("License_Application_Label")}
                                        name="application"
                                        textField="applicationName"
                                        data={applicationsData}
                                        dataItemKey="applicationId"
                                        style={{ width: '100%' }}
                                        value={selectedApplication}
                                        onChange={filterAppId}
                                    />

                                </div>

                                <div className="col-lg-2">
                                    <DatePicker
                                        width={"100%"}
                                        format="d/MM/yyyy"
                                        label={t("Licenses_CreationDate_Label")}
                                        value={filterData.created || null}
                                        onChange={filterCreationDate}
                                    />
                                </div>

                                <div className="col-lg-1">
                                    <FloatingLabel
                                        style={{ width: "100%" }}
                                        label={t("Licenses_Enabled_Label")}
                                        editorId={"filterIsDisabledSelector"}
                                        editorValue={loading ? "" : "null"}
                                    >
                                        <DropDownList
                                            id={"filterIsDisabledSelector"}
                                            data={statusModes}
                                            textField="name"
                                            dataItemKey="value"
                                            value={statusModeSelected || { name: t("License_All_StatusMode_SelectList"), value: 3 }}
                                            onChange={filterIsDisabled}
                                        />
                                    </FloatingLabel>
                                </div>



                                <div className="col-lg-2" ></div>
                                <div className="col-lg-2 d-flex">

                                    <button
                                        onClick={clickFilter}
                                        style={{ margin: "0" }}
                                        className="k-button ms-auto mt-auto mb-0"
                                    >
                                        <span className="k-icon k-i-filter" /> &nbsp; {t("Global_Button_Text_Filter")}
                                    </button>
                                </div>

                                <div className="col-lg-1 d-flex">
                                    <button
                                        onClick={clearFilters}
                                        style={{ margin: "0" }}
                                        className="k-button ms-auto mt-auto mb-0"
                                    >
                                        <span className="k-icon k-i-trash" /> &nbsp; {t("Global_Button_Text_Clear_Filter")}
                                    </button>
                                </div>

                                <div className="d-flex align-items-center gap-2 mt-3">
                                    <button
                                        onClick={addTagInput}
                                        className="k-button k-button-icon k-rounded-circle"
                                        title={t("Global_Button_Text_Create_Filter_Tag")}
                                        style={{
                                            width: '20px',
                                            height: '20px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: 0,
                                        }}
                                    >
                                        <span className="k-icon k-i-plus" />
                                    </button>

                                    <span className="fw-normal small">{t("Filter_Tag_by_Tag")}</span>
                                </div>


                                {tagInputs.map((input, index) => (
                                    <div className="row align-items-end" key={index}>
                                        <div className="col-lg-2" style={{ marginTop: "4px" }}>
                                            <DropDownList
                                                label={t("Applications_Tags_Title")}
                                                name="tag"
                                                textField="tagName"
                                                data={tagsData}
                                                dataItemKey="tagName"
                                                style={{ width: '100%' }}
                                                value={input.tag}
                                                onChange={(e) => handleTagChange(index, e.value)}
                                            />
                                        </div>

                                        <div className="col-lg-2" style={{ marginTop: "4px" }}>
                                            <Input
                                                label={t("LicenseTags_Value_Label")}
                                                onChange={(e) => handleValueChange(index, e)}
                                                value={input.value}
                                            />
                                        </div>

                                        <div className="col-lg-1" style={{ marginTop: "4px" }}>
                                            <button
                                                onClick={() => removeTagInput(index)}
                                                className="k-button"
                                                title={t("Global_Button_Text_Delete_Filter_Tag")}
                                            >
                                                <span className="k-icon k-i-minus-circle" />
                                            </button>
                                        </div>
                                    </div>
                                ))}



                            </div>
                        </div>
                    </div>
                    <br />
                    {loading && loadingPanel}

                    <Grid
                        editField='inEdit'
                        cellRender={loadingCell}
                        pageable={{
                            pageSizes: ListOfPaged(),
                        }}
                        data={licencesData}
                        total={total}
                        skip={pageState.skip}
                        take={pageState.take}
                        scrollable={'none'}
                        sortable={{
                            allowUnsort: true,
                            mode: "single"
                        }}
                        sort={sortState}
                        onSortChange={sortChange}
                        onPageChange={pageChange}
                    >
                        {props.isAdmin ? <GridToolbar>
                            <div>
                                <Link to={'/licenses/Create'}>
                                    <button title={t("Licenses_Button_Tooltip_Create")} className="k-button k-primary">
                                        &nbsp;<span className="k-icon k-i-plus-circle" />&nbsp; {t("Global_Button_Text_Create")} &nbsp;
                                    </button>
                                </Link>
                            </div>

                            <div>
                                <button
                                    title={t("License_Disabled_Label")}
                                    className="k-button k-primary-lean"
                                    onClick={getSelectedLicenses}
                                    disabled={!isAnySelected}

                                >
                                    &nbsp;<span className="k-icon k-i-lock" />&nbsp; {t("License_Disabled_Label")} &nbsp;
                                </button>
                            </div>

                        </GridToolbar> : ""}



                        <Column cell={CheckboxCell} title={t("License_Disabled_Label")} width="40px" />
                        <Column cell={CommandCell} width={props.isAdmin ? "130px" : "80px"} sortable={false} />
                        <Column cell={AllowUpdatesCommandCell} sortable={false} />
                        <Column cell={IsDisabledCommandCell} field="isDisabled" title={" "} sortable={true} />
                        <Column field="creationDate" title={t("Licenses_CreationDate_Label")} format="{0:d}" sorteable={true} />
                        <Column field="clientName" title={t("Licenses_ClientId_Label")} width="250px" />
                        <Column field="appId" title={t("Licenses_AppId_Label")} width="150px" />
                        <Column cell={MachineCodeTruncateCommandCell} title={t("Licenses_MachineKey_Label")} />
                        <Column cell={LicenseCodeTruncateCommandCell} title={t("Licenses_LicenseCode_Label")} />

                    </Grid>
                </IntlProvider>
            </LocalizationProvider>
        </div>
    );
}

